import { render, staticRenderFns } from "./SettingsSeo.vue?vue&type=template&id=e63283a4&"
import script from "./SettingsSeo.vue?vue&type=script&lang=js&"
export * from "./SettingsSeo.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSeo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports